import Navbar from "./components/Navbar/Navbar";
import PublicPresale from "./components/PublicPresale/PublicPresale";
import Dashbord from "./components/Dashbord/Dashbord";
import Stake from "./components/Stake/Stake";

// Browser Router

import { BrowserRouter, Routes, Route } from "react-router-dom";

// Scroll to Top

import ScrollToTop from "react-scroll-to-top";
import { AppContext } from "./utils";
import { useContext, useEffect, useState } from "react";
import {
  toPlainString,
  useNode1Contract,
  useNode2Contract,
  useNode3Contract,
  useMainnodeContract,
} from "./ConnectivityAss/hooks";
import { formatUnits } from "@ethersproject/units";
import moment from "moment";
import Loading from "./loading";
import Bridge from "./components/Bridge/Bridge";

//transtion

function App() {
  const [loading, setloading] = useState(false);
  const [switchNetwork, setswitchNetwork] = useState(false);
  const [totalNode1, setTotalNode1] = useState(0);
  const [totalNode2, setTotalNode2] = useState(0);
  const [totalNode3, setTotalNode3] = useState(0);

  const { account, signer, connect } = useContext(AppContext);
  const mainNodeContract = useMainnodeContract(signer);
  const Node1Contract = useNode1Contract(signer);
  const Node2Contract = useNode2Contract(signer);
  const Node3Contract = useNode3Contract(signer);
  const [userNodesData, setuserNodesData] = useState({
    node1Data: [],
    node2Data: [],
    node3Data: [],
    totalRewardNode1: 0,
    totalRewardNode2: 0,
    totalRewardNode3: 0,
  });

  // State For CON Value

  const [ConValue, setConValue] = useState({
    con1: 0,
    con2: 0,
    con3: 0,
  });

  const init = async () => {
    try {
      setloading(true);
      const [totalNode1, totalNode2, totalNode3, { node1, node2, node3 }] =
        await Promise.all([
          Node1Contract.totalNodesCreated(),
          Node2Contract.totalNodesCreated(),
          Node3Contract.totalNodesCreated(),
          mainNodeContract.getNodeNumberOf(account),
        ]);

      setTotalNode1(+totalNode1);
      setTotalNode2(+totalNode2);
      setTotalNode3(+totalNode3);

      let obj = {
        node1Data: [],
        node2Data: [],
        node3Data: [],
        totalRewardNode1: 0,
        totalRewardNode2: 0,
        totalRewardNode3: 0,
      };
      let node1Array = [];
      let node2Array = [];
      let node3Array = [];
      let totalRewardNode1 = 0;
      let totalRewardNode2 = 0;
      let totalRewardNode3 = 0;
      if (+node1 > 0) {
        const [name, reward, creationTime] = await Promise.all([
          Node1Contract._getNodesNames(account),
          Node1Contract._getNodesRewardAvailable(account),
          Node1Contract._getNodesCreationTime(account),
        ]);
        let names = name.split("#");
        let times = creationTime.split("#");
        let rewards = reward.split("#");
        var current1 = moment().format("X");
        console.log("called", creationTime);

        for (let index = 0; index < rewards.length; index++) {
          let [date, { _lastClaimTime, _isolationPeriod, _claimTax }] =
            await Promise.all([
              mainNodeContract.getNodeDueDate(
                account,
                "0",
                times[index].toString()
              ),
              Node1Contract.getNodeInfo(account, times[index].toString()),
            ]);

          let difference = +date.dueDate - +current1;
          const days = (difference / (60 * 60 * 24)).toFixed(0);
          const hours = ((difference % (60 * 60 * 24)) / (60 * 60)).toFixed(0);

          node1Array.push({
            name: names[index],
            reward: (+formatUnits(rewards[index])).toFixed(8),
            time: {
              days,
              hours,
            },
            isolationTime: +_lastClaimTime + +_isolationPeriod,
            creationTime: times[index].toString(),
            type: "SILVER",
          });
          totalRewardNode1 += +formatUnits(rewards[index]);
          // console.log(totalRewardNode1, "totalRewardNode1");
        }
      }
      if (+node2 > 0) {
        const [name, reward, creationTime] = await Promise.all([
          Node2Contract._getNodesNames(account),
          Node2Contract._getNodesRewardAvailable(account),
          Node2Contract._getNodesCreationTime(account),
        ]);
        let names = name.split("#");
        let rewards = reward.split("#");
        let times = creationTime.split("#");
        var current2 = moment().format("X");
        for (let index = 0; index < rewards.length; index++) {
          console.log(times[index].toString());
          let [date, { _lastClaimTime, _isolationPeriod, _claimTax }] =
            await Promise.all([
              mainNodeContract.getNodeDueDate(
                account,
                "1",
                times[index].toString()
              ),
              Node2Contract.getNodeInfo(account, times[index].toString()),
            ]);
          let difference = +date.dueDate - +current2;
          const days = (difference / (60 * 60 * 24)).toFixed(0);
          const hours = ((difference % (60 * 60 * 24)) / (60 * 60)).toFixed(0);

          node2Array.push({
            name: names[index],
            reward: (+formatUnits(rewards[index])).toFixed(8),
            time: {
              days,
              hours,
            },
            isolationTime: +_lastClaimTime + +_isolationPeriod,
            creationTime: times[index].toString(),
            type: "DIAMOND",
          });
          totalRewardNode2 += +formatUnits(rewards[index]);
        }
      }
      if (+node3 > 0) {
        const [name, reward, creationTime] = await Promise.all([
          Node3Contract._getNodesNames(account),
          Node3Contract._getNodesRewardAvailable(account),
          Node3Contract._getNodesCreationTime(account),
        ]);
        let names = name.split("#");
        let rewards = reward.split("#");
        let times = creationTime.split("#");
        var current3 = moment().format("X");

        for (let index = 0; index < rewards.length; index++) {
          let [date, { _lastClaimTime, _isolationPeriod, _claimTax }] =
            await Promise.all([
              mainNodeContract.getNodeDueDate(
                account,
                "2",
                times[index].toString()
              ),
              Node3Contract.getNodeInfo(account, times[index].toString()),
            ]);
          let difference = +date.dueDate - +current3;
          const days = (difference / (60 * 60 * 24)).toFixed(0);
          const hours = ((difference % (60 * 60 * 24)) / (60 * 60)).toFixed(0);

          node3Array.push({
            name: names[index],
            reward: (+formatUnits(rewards[index])).toFixed(8),
            time: {
              days,
              hours,
            },
            isolationTime: +_lastClaimTime + +_isolationPeriod,
            creationTime: times[index].toString(),
            type: "GOLD",
          });
          totalRewardNode3 += +formatUnits(rewards[index]);
        }
      }
      obj.node1Data = node1Array;
      obj.node2Data = node2Array;
      obj.node3Data = node3Array;
      obj.totalRewardNode1 = toPlainString(totalRewardNode1.toFixed(8));
      obj.totalRewardNode2 = toPlainString(totalRewardNode2.toFixed(8));
      obj.totalRewardNode3 = toPlainString(totalRewardNode3.toFixed(8));
      setuserNodesData(obj);
      setloading(false);
    } catch (e) {
      console.log(e, "error");
      setloading(false);
    }
  };
  console.log(userNodesData);

  useEffect(() => {
    if (window.location.href.includes("?ref=")) {
      let getAddress = window.location.href.split("?ref=")[1];
      let final = getAddress.slice(0, 42);
      localStorage.setItem("contexia_refAddress", final);
    }
    if (!account) {
      connect();
    }
    if (account) {
      init();
    }
  }, [account]);
  return (
    <div>
      <Loading loading={loading} />
      <ScrollToTop
        color="white"
        style={{
          background: "#FAA631",
        }}
        smooth
      />
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<PublicPresale />} />
        </Routes>
        <Routes>
          <Route
            path="/store"
            element={
              <Dashbord
                totalNode1={totalNode1}
                totalNode2={totalNode2}
                totalNode3={totalNode3}
                userNodesData={userNodesData}
                init={init}
                setConValue={setConValue}
                ConValue={ConValue}
              />
            }
          />
        </Routes>
        <Routes>
          <Route path="/stake" element={<Stake />} />
          <Route path="/swap" element={<Bridge />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
